import { createApp } from 'vue'
import { createLiveStream } from '@codecures/live-stream-vue'
import App from './App.vue'
import { client } from './client'
import { router } from './router'
import './style.css'

createApp(App).use(createLiveStream(client)).use(router).mount('#app')
